import { supabase } from "../../Supabase/Config";

export class WorkspaceError extends Error {
  constructor(code, status) { super(code); this.code = code; this.status = status; }
}

export async function workspaceRequest(path, options = {}, token) {
  const session = token ? { access_token: token } : (await supabase.auth.getSession()).data.session;
  if (!session?.access_token && !path.startsWith('/demo')) throw new WorkspaceError('unauthorized', 401);
  let response;
  try {
    response = await fetch(`/api/workspaces${path}`, {
      ...options,
      headers: {
        ...(session?.access_token ? { Authorization: `Bearer ${session.access_token}` } : {}),
        ...(!(options.body instanceof FormData) && options.body ? { 'Content-Type': 'application/json' } : {}),
        ...options.headers
      }
    });
  } catch { throw new WorkspaceError('network', 0); }
  if (!response.ok) {
    let payload = {};
    try { payload = await response.json(); } catch {}
    // Never display untrusted backend messages or confidential exception details.
    const codes = {UNAUTHORIZED:'unauthorized',NOT_FOUND:'not_found',INVALID_FILE:'invalid_file',DOCUMENT_TOO_LARGE:'file_too_large',INVALID_INPUT:'invalid_input',RATE_LIMITED:'rate_limited',EXTRACTION_UNAVAILABLE:'extraction_unavailable',EMPTY_DOCUMENT:'empty_document',INVALID_SOURCE:'invalid_source',NO_FIXED_DATE:'no_fixed_date',INVALID_DATE:'invalid_date',ACTION_LIMIT:'capacity_reached',CONSENT_REQUIRED:'invalid_input'};
    throw new WorkspaceError(codes[payload.code] || ({401:'unauthorized',403:'unauthorized',404:'not_found',413:'file_too_large',429:'rate_limited'}[response.status] || 'server'), response.status);
  }
  return response.status === 204 ? {} : response.json();
}

export const workspacesApi = {
  list: token => workspaceRequest('', {}, token),
  get: (id, token) => workspaceRequest(`/${encodeURIComponent(id)}`, {}, token),
  demo: () => workspaceRequest('/demo'),
  create: (name, token) => workspaceRequest('', {method:'POST',body:JSON.stringify({name,consent:true})}, token),
  patch: (id, data, token) => workspaceRequest(`/${encodeURIComponent(id)}`, {method:'PATCH',body:JSON.stringify(data)}, token),
  remove: (id, token) => workspaceRequest(`/${encodeURIComponent(id)}`, {method:'DELETE',body:JSON.stringify({confirm:true})}, token),
  upload: (id, file, token) => {
    const body = new FormData();
    body.append('file',file); body.append('consent','true'); body.append('language','en');
    return workspaceRequest(`/${encodeURIComponent(id)}/versions`,{method:'POST',body},token);
  },
  compare: (id, from, to, token) => workspaceRequest(`/${encodeURIComponent(id)}/compare?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,{},token),
  addAction: (id, data, token) => workspaceRequest(`/${encodeURIComponent(id)}/actions`,{method:'POST',body:JSON.stringify(data)},token),
  patchAction: (id, actionId, data, token) => workspaceRequest(`/${encodeURIComponent(id)}/actions/${encodeURIComponent(actionId)}`,{method:'PATCH',body:JSON.stringify(data)},token),
  removeAction: (id, actionId, token) => workspaceRequest(`/${encodeURIComponent(id)}/actions/${encodeURIComponent(actionId)}`,{method:'DELETE'},token)
};

const eventSession = typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : String(Math.random()).slice(2);
const sentEvents = new Set();
export function trackWorkspaceEvent(event) {
  if (!['demo_opened','demo_signup_clicked','upgrade_interest'].includes(event) || sentEvents.has(event)) return;
  sentEvents.add(event);
  fetch('/api/workspace-events',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({event,dedupeKey:`ws_${eventSession.replace(/[^a-zA-Z0-9_-]/g,'_')}_${event}`.slice(0,80)})}).catch(()=>{});
}